<template>
  <div v-if="!hidden">
    <div
      :key="value.then"
      v-if="value.then && value.then.scope"
      :class="[
        'stepBox',
        {
          passed:
            mode == 'testing' &&
            value.then._resolved &&
            value.then._resolved.error == null,
        },
      ]"
    >
      <v-container :key="value.then">
        <v-row>
          <v-col cols="12" class="flex-column">
            <div v-if="!value.then.fork && !value.then.expr">
              <scopeField
                :scope="value.then.scope"
                :field="value.then.field"
                :constants="constants"
                :mode="mode"
                :_resolved="value.then._resolved"
              />
            </div>

            <!-- FORK -->
            <template v-if="value.then && value.then.fork && !value.then.expr">
              <scopeField
                :scope="value.then.scope"
                :field="value.then.field"
                :constants="constants"
                :mode="mode"
                :_resolved="value.then._resolved"
              />

              <div class="d-flex flex-row fork mt-5 px-0" :key="value.then">
                <div
                  class="col col-5"
                  style="position: relative; text-align: left;"
                >
                  <div class="divider left">
                    <scopeField
                      :scope="value.then.fork.lowerLimit.scope"
                      :field="value.then.fork.lowerLimit.field"
                      :constants="constants"
                      :mode="mode"
                      :_resolved="value.then.fork.lowerLimit._resolved"
                      :breakScopeField="false"
                    />
                    <span><v-divider vertical></v-divider></span>
                  </div>

                  <scopeField
                    :scope="value.then.fork.a.scope"
                    :field="value.then.fork.a.field"
                    :constants="constants"
                    :mode="mode"
                    :_resolved="value.then.fork.a._resolved"
                    :breakScopeField="false"
                  />
                </div>

                <div
                  class="col col-2"
                  style="justify-content: center; text-align: center;"
                >
                  <scopeField
                    :scope="value.then.fork.b.scope"
                    :field="value.then.fork.b.field"
                    :constants="constants"
                    :mode="mode"
                    :_resolved="value.then.fork.b._resolved"
                    :breakScopeField="false"
                  />
                </div>

                <div
                  class="col col-5"
                  style="position: relative; flex-direction: column; align-items: flex-end; justify-content: flex-end; text-align: right;"
                >
                  <div class="divider right">
                    <scopeField
                      :scope="value.then.fork.upperLimit.scope"
                      :field="value.then.fork.upperLimit.field"
                      :constants="constants"
                      :mode="mode"
                      :_resolved="value.then.fork.upperLimit._resolved"
                      :breakScopeField="false"
                    />
                    <span><v-divider vertical></v-divider></span>
                  </div>

                  <scopeField
                    :scope="value.then.fork.c.scope"
                    :field="value.then.fork.c.field"
                    :constants="constants"
                    :mode="mode"
                    :_resolved="value.then.fork.c._resolved"
                    :breakScopeField="false"
                  />
                </div>
              </div>
            </template>

            <!-- TERNARY -->
            <div
              class="d-flex justify-space-between ternary"
              v-else-if="value.then && value.then.ternary && !value.then.expr"
            >
              <div>
                <b>true</b>
                <scopeField
                  :scope="value.then.ternary.a.scope"
                  :field="value.then.ternary.a.field"
                  :constants="constants"
                  :mode="mode"
                  :_resolved="value.then.ternary.a._resolved"
                  :breakScopeField="false"
                />
              </div>

              <div>
                <b>false</b>
                <scopeField
                  :scope="value.then.ternary.b.scope"
                  :field="value.then.ternary.b.field"
                  :constants="constants"
                  :mode="mode"
                  :_resolved="value.then.ternary.b._resolved"
                  :breakScopeField="false"
                />
              </div>
            </div>

            <!-- EXPRESSION -->
            <template v-if="value.then && value.then.expr">
              <template v-for="(expr, exprIndex) in value.then.expr.terms">
                <template v-if="exprIndex > 0 && expr.operator != 'default'">
                  {{ operators.find((o) => o.name == expr.operator).label }}
                </template>

                {{ expr.scope }}.{{
                  expr.scope != "value" ? expr.field : expr.value
                }}
              </template>
            </template>
          </v-col>
        </v-row>
      </v-container>

      <div class="actions mt-1" v-if="mode == 'default'">
        <v-btn
          icon
          plain
          small
          color="grey"
          @click="editAllocation(value.then)"
        >
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>

        <v-btn
          icon
          plain
          small
          color="grey"
          @click="deleteAllocation(value, parent, index)"
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </div>
    </div>

    <template v-else>
      <v-btn
        block
        tile
        elevation="0"
        :class="['stepBox plain mb-2', { 'is-hidden': mode == 'testing' }]"
        @click="editAllocation(value.then)"
      >
        <v-icon left>mdi-plus</v-icon><lang t="RULE-ADD_ALLOCATION" />
      </v-btn>
    </template>
    <draggable v-model="step.if.children" :disabled="mode === 'testing'" >
    <allocation-box
      v-for="(child, childIndex) in step.if.children"
      :key="childIndex"
      :parent="step"
      :value="child"
      :hidden="childHidden"
      :step="child"
      :index="childIndex"
      :mode="mode"
      class="mt-2"
      :constants="constants"
      @editAllocation="editAllocation"
      @deleteAllocation="deleteAllocation"
    />
    </draggable>
  </div>
</template>

<script>
import scopeField from "./showScopeField";
import draggable from 'vuedraggable'

export default {
  components: {
    scopeField,
    draggable
  },

  name: "allocationBox",

  props: {
    value: {
      type: Object,
    },
    step: {
      type: Object,
    },
    parent: {
      type: Object,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    stageIndex: {
      type: Number,
    },
    index: {
      type: Number,
    },
    constants: {
      type: Array,
    },
    mode: {
      type: String,
      default: "default",
    },
    operators: {
      type: Object,
    },
  },

  data() {
    return { childHidden: false };
  },
  computed:{
    hideElement(){
      return this.$store.getters.isCurrentConditionBoxHidden(this.step.if);
    }
  },
  watch:{
    hideElement:{
      handler(status){
        this.childHidden = status;
      }
    },
    hidden(status){
      this.childHidden = status;
    }
  },

  created() {
    this.childHidden = this.hideElement;
  },

  methods: {

    editAllocation(allocation) {
      this.$emit("editAllocation", allocation, this.stageIndex);
    },

    deleteAllocation(step, parent, index) {
      this.$emit("deleteAllocation", step, parent, index);
    },
  },
};
</script>

<style lang="scss">
.ternary,
.fork {
  min-width: 250px;
  max-width: 100% !important;
  width: 100% !important;
  border-radius: 4px;
}

.ternary {
  > div {
    padding: 2px 4px;
  }
}

.fork {
  font-size: 11px;
  line-height: inherit;
  background: linear-gradient(
    90deg,
    rgba(27, 153, 167, 0.3762548964898459) 25%,
    rgba(27, 153, 167, 1) 75%
  );

  .col {
    line-height: 1;
    padding: 4px 6px;
    display: flex;
    align-items: center;

    .divider {
      position: absolute;
      bottom: 66%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      left: 0;
      right: 0;

      > span {
        display: block;
        line-height: 1;
        hr {
          margin-top: 4px;
          height: 12px;
        }
      }

      &.right {
        left: -33%;
      }
      &.left {
        right: -33%;
      }
    }
  }
}
</style>
